module.exports = __webpack_public_path__ + "img/reply-1.87d478a5.jpg";